require('materialize-css/dist/js/materialize.min')

require('../src/home/base')

require.context('../images', true)

require('../src/service-worker/register')